define("SuiteDB.SDBQuoteImprovements.SDBQuoteImprovement.View", [
  "suitedb_sdbquoteimprovements_sdbquoteimprovement.tpl",
  "Backbone",
  "Profile.Model",
  "SuiteDB.SDBQuoteImprovements.SDBQuoteImprovement.Model",
], function (
  suitedb_sdbquoteimprovements_sdbquoteimprovement_tpl,
  Backbone,
  ProfileModel,
  SDBQuoteImprovementModel
) {
  "use strict";

  return Backbone.View.extend({
    template: suitedb_sdbquoteimprovements_sdbquoteimprovement_tpl,

    initialize: function initialize(options) {
      var self = this;
      var Profile = ProfileModel.getInstance();
      var Model = SDBQuoteImprovementModel.getInstance();
      this.updateCount = function updateCount() {
        if (!options.container.ProductListModule) return;
        options.container.ProductListModule.Utils.getRequestAQuoteProductList().done(
          function (json) {
            if (!json.items) return;
            self.count = json.items.reduce(function (sum, item) {
              return sum + item.quantity;
            }, 0);
            self.render();
          }
        );
      };
      Model.on("change:QuoteChanged", function () {
        if (Profile.get("isLoggedIn") !== "T") return;
        self.updateCount();
      });
      Model.on("change:QuoteQuantityChanged", function (model, value) {
        self.count += value;
        self.render();
        Model.unset("QuoteQuantityChanged", { silent: true });
      });
      Model.on("change:QuoteSetQuantity", function (model, value) {
        self.count = value;
        self.render();
        Model.unset("QuoteSetQuantity", { silent: true });
      });
      if (Profile.get("isLoggedIn") !== "T") return;
      this.updateCount();
    },

    events: {},

    bindings: {},

    childViews: {},

    getContext: function getContext() {
      return {
        count: this.count || 0,
      };
    },
  });
});
